import { formatBusinessDate } from "@web/utils/date-time";
import { getBusinessConfig } from "@web/config/business-config";

/**
 * Standard display format for a person's name. This intentionally lives at the
 * API/display boundary so legacy lowercase records are presented consistently
 * without changing usernames, emails, audit payloads, or non-person labels.
 */
export function formatPersonName(value?: string | null): string {
  if (!value) return "";
  return value
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("en-AE")
    .replace(/(^|[-\s'’])\p{L}/gu, (match) => match.toLocaleUpperCase("en-AE"));
}

export function formatCurrency(value?: number | string, currency = getBusinessConfig().currency) {
  const amount = Number(value);
  return Number.isFinite(amount)
    ? new Intl.NumberFormat("en-AE", {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).format(amount)
    : "Price on request";
}
export function formatArea(value?: number | string | null) {
  if (value === null || value === undefined || value === "") return "—";
  const area = Number(value);
  return Number.isFinite(area)
    ? `${new Intl.NumberFormat("en-AE").format(area)} sq ft`
    : "—";
}
export function formatDate(value?: string | null) {
  if (!value) return "—";
  return formatBusinessDate(value);
}
export function safeExternalUrl(value?: string | null) {
  if (!value) return null;
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
}
